import { render } from "./Header.vue?vue&type=template&id=dfbfcdda&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=dfbfcdda&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dfbfcdda"

export default script